import { useLayoutEffect, useState } from 'react';

/**
 * Measures the page's content card (`.acc-card` — the grid region right of the
 * nav, below the header) so a MAXIMIZED nested popup fills the SAME footprint as
 * the top-level Country/City detail forms, instead of covering the whole
 * viewport. Returns an inline `position:fixed` style while `active`, else
 * `undefined` (the dialog falls back to its normal centred size on restore).
 */
export function useContentRectStyle(active: boolean) {
  const [rect, setRect] = useState<{ top: number; left: number; width: number; height: number } | null>(null);
  useLayoutEffect(() => {
    if (!active) { setRect(null); return; }
    const measure = () => {
      const el = document.querySelector('.acc-card') as HTMLElement | null;
      const r = el?.getBoundingClientRect();
      if (r) setRect({ top: r.top, left: r.left, width: r.width, height: r.height });
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [active]);
  return active && rect
    ? { position: 'fixed' as const, top: rect.top, left: rect.left, width: rect.width,
        height: rect.height, maxWidth: 'none' as const, maxHeight: 'none' as const, margin: 0 }
    : undefined;
}
